import { MobXProviderContext } from 'mobx-react';
import { useCallRouter } from 'Modules/softphone/hooks';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { RootStoreProps } from 'Stores/RootStore.types';
import { pushToGTMDataLayer } from 'Utils/analytics';

export const useContactActions = () => {

  const navigate = useNavigate();

  const { conversation: conversationStore } = useContext(
    MobXProviderContext
  ) as RootStoreProps;

  // Use the unified router hook
  const { callWithPerson } = useCallRouter();

  const callPerson = (personId: string) => {
    pushToGTMDataLayer('contact_start_call');

    void callWithPerson(personId, null);
  };

  const callExternal = (phone: string) => {
    pushToGTMDataLayer('contact_start_call');

    void callWithPerson(null, phone);
  };

  const messagePerson = (personId: string) => {
    pushToGTMDataLayer('contact_start_chat');

    void conversationStore
      .loadOrCreateConversationWithPost(personId)
      .then((resp) => navigate(`/chat/conversations/${resp.data.id}/menu`));
  };

  const messageExternal = (phoneNumber: string) => {
    pushToGTMDataLayer('contact_start_SMS');

    void conversationStore
      .loadOrCreateConversationWithPost(null, phoneNumber)
      .then((resp) => navigate(`/chat/conversations/${resp.data.id}/menu`));
  };

  const videoCallPerson = (personId: string) => {
    void conversationStore
      .loadOrCreateConversationWithPost(personId)
      .then((resp) => {
        const conversationId = resp.data.id.toString();
        void conversationStore.postConferenceByConversationId(conversationId);

        if (window['dataLayer']) {
          (window['dataLayer'] as any[]).push({
            event: 'placeVideoConference',
            conversationId,
          });
        }
      });
  };

  return {
    callPerson,
    callExternal,
    messagePerson,
    messageExternal,
    videoCallPerson,
  };
};
